module.exports = __webpack_public_path__ + "assets/img/yellow.03c277b4.png";